module.exports = "/assets/1127493d7af4b0fcade6427ba766868e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9W.png
// module id = 2305
// module chunks = 0